import React, { Fragment } from 'react'
import { BETREPLY_ELEMENTS_PROPS } from './interface'
import { copyToClipboard } from 'functions/copy/copyToClipboard'
import { Reply } from './ElementsStyled'

export default function Seeds({
  content,
  func,
  colors,
}: BETREPLY_ELEMENTS_PROPS) {
  return (
    <Fragment>
      {content.map((item: any, id: number) => (
        <Reply
          key={id}
          colors={colors.secondary}
          majorTextColor={colors.majorTextColor}
          minorTextColor={colors.minorTextColor}
          textAreaColor={colors.textAreaColor}
        >
          <h3>{item.title}</h3>
          <textarea
            value={item.content}
            spellCheck='false'
            readOnly
            onClick={e => copyToClipboard(e, func)}
          />
        </Reply>
      ))}
    </Fragment>
  )
}
